import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import FacilitatorTemplateSingle from './single/component.jsx';
FacilitatorTemplateList.propTypes = {
    onTemplateClick: PropTypes.func,
    selectedTemplateID: PropTypes.string
};
export default function FacilitatorTemplateList(_a) {
    var _b = _a.onTemplateClick, onTemplateClick = _b === void 0 ? null : _b, _c = _a.selectedTemplateID, selectedTemplateID = _c === void 0 ? '' : _c;
    var gameTemplates = useSelector(function (state) { return state.general.gameTemplates; });
    return (React.createElement("div", { className: "cardview" }, gameTemplates.map(function (x, index) { return (React.createElement(FacilitatorTemplateSingle, { key: index, onTemplateClick: onTemplateClick, id: x._id, name: x.name, description: x.description, selectedTemplateID: selectedTemplateID, isClickable: true })); })));
}
